export default __webpack_public_path__ + "static/media/gallery_02.9d34e086.jpg";